import React, { useEffect, useRef, useState } from "react";
import "./OutagePage.css";

const OutagePage = () => {
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);


    //hyperlink
    const textareaRef = useRef(null);

    const [showLinkPopup, setShowLinkPopup] = useState(false);
    const [linkUrl, setLinkUrl] = useState("");

    const [selection, setSelection] = useState({
        start: 0,
        end: 0
    });

    useEffect(() => {
        if (!editingId) {
            loadMessages();
            checkuser()
        }
    }, []);

    const loadMessages = async () => {
        setLoading(true);

        try {
            const response = await fetch(
                "/api/outage/all"
            );

            const data = await response.json();

            setMessages([
                {
                    id: data.message._id,
                    message: data.message.message,
                },
            ]);

        } catch (err) {
            console.log(err);
        }

        setLoading(false);
    };

    const checkuser = async () => {
    setLoading(true);
    try {
        const response = await fetch("/api/access/mine");
        const data = await response.json();
        setIsAdmin((data.features || []).includes("outage"));
    } catch (err) {
        console.log(err);
        setIsAdmin(false);
    }
    setLoading(false);
};


    const clearForm = () => {
        setMessage("");
        setEditingId(null);
    };

    const openSubmitPopup = () => {
        if (!message.trim()) return;
        handleSubmit()
    };

    const handleSubmit = async () => {
        try {
            let status = 500;
            let response;
            if (editingId) {
                response = await fetch("/api/outage/update", {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        _id: editingId,
                        updates: {
                            message: message,
                        },
                    }),
                });
                status = await response.status
            }
            else {
                response = await fetch("/api/outage/new", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ message }),
                });
                status = await response.status
            }

            if (status == 200) {
                alert(editingId ? "Updated Successfully" : "Submitted Successfully");
            } else if (status == 201) {
                alert("You can create only one outage");
            } else {
                alert(editingId ? "Error while update" : "Error while submit");
            }
            loadMessages();
            clearForm();
        } catch (e) {
            console.log(e);
        }
    };

    const handleEdit = async (item) => {
        setEditingId(item.id);
        setMessage(item.message);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this message?")) return;

        await fetch("/api/outage/delete", {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                _id: id,
            }),
        });

        setMessages(messages.filter((x) => x.id !== id));
    };

    const openLinkPopup = () => {
        const textarea = textareaRef.current;

        setSelection({
            start: textarea.selectionStart,
            end: textarea.selectionEnd,
        });

        setShowLinkPopup(true);
    };

    const insertHyperlink = () => {
        const { start, end } = selection;

        const selectedText = message.substring(start, end);

        const link =
            selectedText.length > 0
                ? `[${selectedText}](${linkUrl})`
                : `[Please Insert Text To Display](${linkUrl})`;

        const updated =
            message.substring(0, start) +
            link +
            message.substring(end);

        setMessage(updated);

        setShowLinkPopup(false);
        setLinkUrl("");
    };

    return (
        <div className="outage-container">

            <h2 className="page-title">
                Outage Message Management
            </h2>

            {loading && (
                <div className="loading-bar">
                    <div className="loading-progress"></div>
                </div>
            )}

            {
                isAdmin ? (<div className="form-card">

                    <label>Outage Message</label>

                    <div className="textarea-toolbar">
                        <button
                            type="button"
                            className="link-btn"
                            onClick={openLinkPopup}
                        >
                            🔗 Add Hyperlink
                        </button>
                    </div>

                    <textarea
                        ref={textareaRef}
                        className="outage-textarea"
                        rows="4"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />

                    {showLinkPopup && (
                        <div className="modal-overlay">
                            <div className="modal">
                                <h3>Add Hyperlink</h3>

                                <input
                                    type="text"
                                    placeholder="https://example.com"
                                    value={linkUrl}
                                    onChange={(e) => setLinkUrl(e.target.value)}
                                />

                                <div className="modal-buttons">
                                    <button
                                        className="submit-btn"
                                        onClick={insertHyperlink}
                                    >
                                        Add
                                    </button>

                                    <button
                                        className="clear-btn"
                                        onClick={() => {
                                            setShowLinkPopup(false);
                                            setLinkUrl("");
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Live Preview */}

                    <div className="preview-section">

                        <span className="preview-label">
                            Message Preview
                        </span>

                        <div className="preview-container">

                            {!message ? (
                                <div className="preview-empty">

                                    <span className="preview-icon">
                                        👁️
                                    </span>

                                    <p>Start typing to see preview...</p>

                                </div>
                            ) : (
                                <div className="preview-card">

                                    <div
                                        className="preview-body"
                                        dangerouslySetInnerHTML={{
                                            __html: message.replace(
                                                /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
                                                '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
                                            )
                                        }}
                                    />

                                </div>
                            )}

                        </div>

                    </div>

                    <div className="button-group">

                        <button
                            className="submit-btn"
                            onClick={openSubmitPopup}
                            disabled={!message.trim()}
                        >
                            {editingId ? "Update" : "Submit"}
                        </button>

                        <button
                            className="clear-btn"
                            onClick={clearForm}
                        >
                            Clear
                        </button>

                    </div>

                </div>) : (<div className="form-card" style={{color:"red"}}>You dont have access to this page</div>)
            }

            <div className="table-card">

                {messages[0]?.id ? (<table>

                    <thead>

                        <tr>

                            <th>Message</th>
                            <th>Edit</th>
                            <th>Delete</th>

                        </tr>

                    </thead>

                    <tbody>

                        {messages.map((item) => (
                            <tr key={item.id}>

                                {/* <td>{item.message}</td> */}
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: item.message.replace(
                                            /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
                                            '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
                                        )
                                    }}
                                ></td>

                                <td>

                                    <button
                                        className="edit-btn"
                                        onClick={() => handleEdit(item)}
                                        disabled= {!isAdmin}
                                    >
                                        Edit
                                    </button>

                                </td>

                                <td>

                                    <button
                                        className="delete-btn"
                                        onClick={() => handleDelete(item.id)}
                                        disabled= {!isAdmin}
                                    >
                                        Delete
                                    </button>

                                </td>

                            </tr>
                        ))}

                    </tbody>

                </table>) : (
                    <span colSpan="3" className="no-data">
                        No Outage data found
                    </span>
                )}

            </div>
        </div>
    );
};

export default OutagePage;